module.exports = __webpack_public_path__ + "static/img/3.86357af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/3.png
// module id = +mq+
// module chunks = 94